// Color constants for the application
export const COLORS = {
  OFF_WHITE: 'var(--off-white)',
  BACKGROUND: 'var(--background-color)',
  TEXT_DARK: '#3E3E3F',
} as const; 